"use client";

import React from "react";
import { FaArrowUp } from "react-icons/fa";

export function StatCard({ title, value, icon, badge, progress, trend }) {
  return (
    <div className="col">
      <div className="card shadow-sm h-100 border-0">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <small className="text-muted fw-semibold">{title}</small>
            <span className={`badge bg-${badge.variant}`}>
              {badge.label}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h3 className="fw-bold mb-1">
                {typeof value === "number"
                  ? value.toLocaleString()
                  : value}
              </h3>

              {trend && (
                <small
                  className={`d-flex align-items-center gap-1 ${
                    trend.isPositive ? "text-success" : "text-danger"
                  }`}
                >
                  <FaArrowUp
                    className={!trend.isPositive ? "rotate-180" : ""}
                  />
                  {trend.value}% <span className="text-muted">vs last month</span>
                </small>
              )}
            </div>

            <div className={`fs-3 text-${badge.variant}`}>
              {icon}
            </div>
          </div>

          {progress !== undefined && (
            <div className="mt-3">
              <div className="progress" style={{ height: "6px" }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${progress}%` }}
                />
              </div>
              <small className="text-muted">
                {progress.toFixed(0)}% completed
              </small>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
